/**
 * Extrai mensagens amigáveis a partir do payload de erro do DRF.
 * Suporta formatos:
 *   { field: ["mensagem"] }
 *   { detail: "mensagem" }
 *   { non_field_errors: ["mensagem"] }
 *   "string pura"
 */
export function extrairMensagensErro(error) {
  if (!error) return ['Erro desconhecido.'];
  const data = error.response?.data;
  if (!data) return [error.message || 'Erro de comunicação com o servidor.'];

  if (typeof data === 'string') return [data];
  if (Array.isArray(data)) return data;

  const mensagens = [];
  Object.entries(data).forEach(([campo, valor]) => {
    if (campo === 'detail' || campo === 'message') {
      mensagens.push(typeof valor === 'string' ? valor : JSON.stringify(valor));
      return;
    }
    if (Array.isArray(valor)) {
      valor.forEach((v) => {
        if (typeof v === 'string') {
          mensagens.push(v);
        } else if (v && typeof v === 'object') {
          mensagens.push(Object.values(v).join(' '));
        }
      });
    } else if (typeof valor === 'string') {
      mensagens.push(`${campo}: ${valor}`);
    } else if (valor && typeof valor === 'object') {
      mensagens.push(`${campo}: ${Object.values(valor).join(' ')}`);
    }
  });
  return mensagens.length > 0 ? mensagens : ['Erro ao processar requisição.'];
}
